export default "__VITE_ASSET__DlT231HT__"